export default {
    props: {
        footerCommand: {
            type: [String, Boolean],
            default: undefined,
            kComposite: 'footer.command'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/Footer.js